import {
  EditVariant,
  OperationVariant,
  RegenerateVariant,
} from "../ai/operation.ts";

import { OptionsMenuAction } from "./analytics.types.ts";

export const ENABLE_MIXPANEL_USER_PROFILE_SYNC = false;

export const OperationVariantToOptionsMenuActionMap = {
  [OperationVariant.enum.next_screen]: OptionsMenuAction.ExpandNextScreen,
  [OperationVariant.enum.error_state]: OptionsMenuAction.ExpandErrorState,
  [OperationVariant.enum.empty_state]: OptionsMenuAction.ExpandEmptyState,
  [OperationVariant.enum.web_version]: OptionsMenuAction.ExpandWebVersion,
  [OperationVariant.enum.mobile_version]: OptionsMenuAction.ExpandMobileVersion,
  [OperationVariant.enum.tablet_version]: OptionsMenuAction.ExpandTabletVersion,
  [OperationVariant.enum.mobile_ios_version]:
    OptionsMenuAction.ExpandMobileIosVersion,
  [OperationVariant.enum.mobile_android_version]:
    OptionsMenuAction.ExpandMobileAndroidVersion,
} as const satisfies Record<OperationVariant, OptionsMenuAction>;

export const RegenerateVariantToOptionsMenuActionMap = {
  [RegenerateVariant.enum.different_layout]:
    OptionsMenuAction.RegenerateDifferentLayout,
  [RegenerateVariant.enum.different_style]:
    OptionsMenuAction.RegenerateDifferentStyle,
  [RegenerateVariant.enum.from_scratch]:
    OptionsMenuAction.RegenerateFromScratch,
} as const satisfies Record<RegenerateVariant, OptionsMenuAction>;

export const EditVariantToOptionsMenuActionMap = {
  [EditVariant.enum.dark_theme]: OptionsMenuAction.EditDarkTheme,
  [EditVariant.enum.light_theme]: OptionsMenuAction.EditLightTheme,
  [EditVariant.enum.make_pretty]: OptionsMenuAction.EditMakePretty,
} as const satisfies Record<EditVariant, OptionsMenuAction>;
